export default __webpack_public_path__ + "assets/images/759c74e41f4ace361f8c87fd909b1a1f.png";